export default {
  badge: '開発中',
  hero_label: 'Own Service',
  hero_title: '生成AI All In One Tool',
  hero_desc: 'すべての生成AIを、ひとつのプラットフォームで。\n企業のAI活用を加速する次世代ツール。',
  overview_label: 'OVERVIEW',
  overview_title: 'すべての生成AIを、ひとつにまとめる。',
  overview_desc: 'ChatGPT・Claude・Gemini・画像生成・音声認識・データ分析——\n乱立する生成AIツールを別々に契約・管理するのは非効率です。\nAIX JAPANが開発した「生成AI All In One Tool」は、あらゆるAI機能を\n単一プラットフォームに統合し、チーム全体のAI活用を加速させます。',
  features_label: 'FEATURES',
  features_title: '6つの中核機能',
  feature_1_tag: 'TEXT',
  feature_1_title: 'マルチAIチャット',
  feature_1_desc: 'GPT-4o、Claude 3.5、Gemini 1.5など主要な大規模言語モデルをひとつの画面から切り替えて利用可能。モデルを比較しながら最適なアウトプットを実現します。',
  feature_2_tag: 'IMAGE',
  feature_2_title: '画像生成・編集',
  feature_2_desc: 'DALL-E 3、Stable Diffusion XL、Midjourney APIに対応。テキストプロンプトから高品質な画像を生成し、インペインティング・スタイル変換も対応します。',
  feature_3_tag: 'VOICE',
  feature_3_title: '音声・文字起こし',
  feature_3_desc: 'Whisperを用いた高精度な音声文字起こし、テキスト読み上げ（TTS）機能を搭載。会議録・インタビューの書き起こしを瞬時に完了します。',
  feature_4_tag: 'DOCUMENT',
  feature_4_title: 'AIドキュメント作成',
  feature_4_desc: '報告書・提案書・プレゼン資料をAIが自動生成。テンプレートを選ぶだけでプロ品質のビジネス文書を数分で作成できます。',
  feature_5_tag: 'ANALYTICS',
  feature_5_title: 'データ分析・可視化',
  feature_5_desc: 'CSV・Excelをアップロードするだけで、AIが自動でデータを分析しグラフ・インサイトを生成。専門知識不要でデータ活用が可能です。',
  feature_6_tag: 'AGENT',
  feature_6_title: 'AIエージェント',
  feature_6_desc: 'タスクを自律的に実行するAIエージェント機能。Web検索・ファイル操作・API連携を組み合わせ、複雑な業務フローを自動化します。',
  interface_label: 'INTERFACE',
  interface_title: 'シンプルで直感的な\nひとつの操作画面',
  interface_1: '統合ダッシュボードで全AIツールに即アクセス',
  interface_2: 'チームメンバーの利用状況・コストを一元管理',
  interface_3: '全会話・生成物の履歴を横断検索',
  interface_4: '権限管理でセキュリティを担保',
  interface_5: 'PC・スマートフォン両対応のレスポンシブUI',
  usecases_label: 'USE CASES',
  usecases_title: '職種・部署を問わず活用できる',
  usecase_1_role: 'マーケター',
  usecase_1_item_1: 'SNS投稿・広告コピーの大量生成',
  usecase_1_item_2: 'バナー画像・クリエイティブ素材の制作',
  usecase_1_item_3: '競合調査・市場分析レポートの自動作成',
  usecase_2_role: 'ビジネス職',
  usecase_2_item_1: '提案書・企画書の素案を瞬時に作成',
  usecase_2_item_2: '会議議事録の自動文字起こし・要約',
  usecase_2_item_3: '社内向けレポート・報告書の効率化',
  usecase_3_role: 'エンジニア',
  usecase_3_item_1: 'コードレビュー・バグ修正の補助',
  usecase_3_item_2: 'API仕様書・技術ドキュメントの生成',
  usecase_3_item_3: 'テストコード・設計書の自動生成',
  usecase_4_role: '経営・管理職',
  usecase_4_item_1: '経営ダッシュボード用データ分析',
  usecase_4_item_2: '事業計画・予算資料の素案作成',
  usecase_4_item_3: '社内AI活用推進のナレッジ共有',
  pricing_label: 'PRICING',
  pricing_title: '料金プラン',
  pricing_subtitle: '全プラン14日間無料トライアル付き。クレジットカード不要。',
  plan_starter_name: 'Starter',
  plan_starter_name_ja: 'スターター',
  plan_starter_price: '¥3,980',
  plan_starter_period: '/月（税込）',
  plan_starter_desc: '個人・スモールチーム向け。まずはAIを試したい方に。',
  plan_starter_cta: '無料トライアルで試す',
  plan_pro_name: 'Pro',
  plan_pro_name_ja: 'プロ',
  plan_pro_price: '¥12,800',
  plan_pro_period: '/月（税込）',
  plan_pro_desc: '中小企業・本格活用チーム向け。全機能フル利用可能。',
  plan_pro_cta: '無料トライアルで試す',
  plan_enterprise_name: 'Enterprise',
  plan_enterprise_name_ja: 'エンタープライズ',
  plan_enterprise_price: '要相談',
  plan_enterprise_period: '',
  plan_enterprise_desc: '大企業・カスタム要件のある組織向け。専任サポート付き。',
  plan_enterprise_cta: 'お問い合わせ',
  plan_recommended: 'RECOMMENDED',
  plan_starter_features: ['マルチAIチャット（月200回）', '画像生成（月50枚）', '音声文字起こし（月60分）', 'AIドキュメント作成（月20件）', 'メールサポート'],
  plan_pro_features: ['マルチAIチャット（無制限）', '画像生成（月500枚）', '音声文字起こし（無制限）', 'AIドキュメント作成（無制限）', 'データ分析・可視化', 'AIエージェント（月100タスク）', 'チャット優先サポート'],
  plan_enterprise_features: ['全機能無制限利用', 'カスタムAIエージェント構築', 'SSO / SAML認証対応', '専用クラウド環境', 'SLA保証', '専任カスタマーサクセス', 'オンボーディング支援'],
  faq_label: 'FAQ',
  faq_title: 'よくあるご質問',
  faq_q1: '無料トライアルはありますか？',
  faq_a1: 'はい、全プランで14日間の無料トライアルをご用意しています。クレジットカード不要で今すぐお試しいただけます。',
  faq_q2: '利用するAIモデルは選べますか？',
  faq_a2: 'はい、GPT-4o・Claude 3.5 Sonnet・Gemini 1.5 Proなど主要モデルをユーザーが自由に切り替えて利用できます。',
  faq_q3: '入力したデータは学習に使用されますか？',
  faq_a3: 'いいえ。お客様のデータは各AIモデルのトレーニングには一切使用されません。Enterprise プランでは専用環境もご用意しています。',
  faq_q4: '既存の社内システムと連携できますか？',
  faq_a4: 'APIを通じてSlack・Notion・Google Workspace・Salesforce等との連携が可能です。Enterprise プランではカスタム連携も対応します。',
  faq_q5: 'プランの途中変更・解約はできますか？',
  faq_a5: 'いつでもプランのアップグレード・ダウングレード・解約が可能です。年払いプランの場合は日割り計算で返金対応いたします。',
  cta_label: 'GET STARTED',
  cta_title: '14日間、無料でお試しください',
  cta_desc: 'クレジットカード不要。すべての機能をすぐにご体験いただけます。\nご不明な点はお気軽にお問い合わせください。',
  cta_trial: '無料トライアルを始める',
  cta_contact: 'デモ・お問い合わせ',
  flow_label: 'FLOW',
  flow_title: '導入の流れ',
  flow_intro: 'お問い合わせから社内定着まで、各ステップでやること・ご用意いただくものを明確にして進めます。',
  flow_steps: [
    {
      no: '01',
      icon: 'ri-chat-3-line',
      title: 'お問い合わせ・無料相談',
      note: '無料',
      duration: '最短即日',
      activities: [
        '利用目的・組織規模・セキュリティ要件のヒアリング',
        '最適なプランのご案内・デモのご提供',
      ],
      deliverables: ['プランのご提案・お見積り'],
      clientAsks: ['想定の利用人数・用途のご共有'],
    },
    {
      no: '02',
      icon: 'ri-flask-line',
      title: '無料トライアル',
      note: '14日間',
      duration: '14日間',
      activities: [
        '少人数チームでの試用と業務での使い勝手・効果の確認',
        '活用方法のご相談',
      ],
      deliverables: ['全機能が使えるトライアル環境'],
      clientAsks: ['試用チームの選定', '使用感のフィードバック'],
    },
    {
      no: '03',
      icon: 'ri-settings-4-line',
      title: '導入・初期設定',
      duration: '約1週間',
      activities: [
        'アカウント発行・組織設定・権限設計',
        '利用ルールの整備と管理者向けのご説明',
      ],
      deliverables: ['本番利用環境', '管理者向けセットアップガイド'],
      clientAsks: ['利用ルールの決定', '利用メンバーリストのご提供'],
    },
    {
      no: '04',
      icon: 'ri-customer-service-2-line',
      title: '活用サポート',
      duration: '継続',
      activities: [
        '活用状況に応じた使い方のご提案',
        '新機能のご案内・お問い合わせサポート',
      ],
      deliverables: ['サポート窓口', '活用のご提案'],
      clientAsks: ['活用状況の定期的なご共有'],
    },
  ],
};
